(function () {
  'use strict';

  angular.module('app').component('confirmXmlList', confirmXmlList());

  function confirmXmlList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalAmounts: '<',
        totalItems: '=',
        onShowConfirmXml: '&',
      },
      controller: ConfirmXmlListListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/confirm-xmls/confirm-xml-list/confirm-xml-list.component.html',
    };
  }

  ConfirmXmlListListCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'SessionService',
    'moment',
    '$location',
    'ConfirmXmlService',
  ];

  function ConfirmXmlListListCtrl(
    config,
    UtilService,
    AbilityService,
    SessionService,
    moment,
    $location,
    ConfirmXmlService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canShow: AbilityService.can('show_confirmxml_accountadmin'),
      canUpdate: AbilityService.can('update_confirmxml_accountadmin'),
      canDestroy: AbilityService.can('destroy_confirmxml_accountadmin'),
    };

    vm.confirmXmlStatuses = angular.copy(config.CONFIRM_XML_STATUSES);
    vm.confirmXmlStatuses.unshift({
      label: 'ALL',
      value: '', // null
    });

    vm.atvCrReceptionStatuses = angular.copy(config.ATV_CR_RECEPTION_STATUSES);
    vm.confirmXmlStatuses.unshift({
      label: 'ALL',
      value: '', // null
    });

    const apiUrl = 'confirm_xml_reports';
    vm.urlXls = apiUrl + '/export_xls.xlsx';
    vm.urlPdf = apiUrl + '/export_pdf.pdf';
    vm.reportName = 'confirm_xml_report';

    // private properties
    // -----------------------
    const dateDisplay = config.DATE_DISPLAY_SHORT;
    // vm.dateDisplay = config.DATE_DISPLAY;

    const company = SessionService.getSelectedAccountCompany();
    const companyId = company.id;

    vm.$onInit = function () {
      vm.atvCrEnabled = company.atv_cr_enabled; // All the time as it is exclusively for atv

      setConfirmXmls(vm.items);

      setDefaultFilters();

      documentDatePicker();
    };

    // public methods
    // -----------------------
    vm.fetchResult = function () {
      vm.loadingItems = true;

      // setFilterStatuses();

      ConfirmXmlService.getConfirmXmls(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalAmounts = data.totalAmounts;

        setConfirmXmls(vm.items);

        vm.totalItems = vm.meta.totalItems;
        vm.loadingItems = false;

        // cleanStatuses();
      });
    };

    vm.refresh = function () {
      vm.fetchResult();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      vm.fetchResult();
    };

    vm.showItem = function (item, mode) {
      if (!vm.permissions.canShow) return;

      vm.onShowItem({ item: item, mode: mode });
    };

    vm.deleteItem = function (item) {
      ConfirmXmlService.deleteConfirmXml(item, vm.fetchResult());
    };

    vm.resendDocToATV = function (item) {
      if (!item.canResend) return;

      vm.loadingDocument = true;
      vm.UtilService.resendDocumentToATV(companyId, item.id, 'confirm_xmls').then(function (data) {
        if (data) {
          item.atv_status = data.atv_status;
          validateItemActions(item);

          // vm.UtilService._successMsg($translate.instant('CONFIRM_XML_RESEND'));
          // vm.fetchResult();
        }

        vm.loadingDocument = false;
      });
    };

    vm.createConfirmXml = function (file) {
      $location.path(`/confirm_xmls/new`).search({ mode: 'xml', xml: file });
    };

    vm.clearDocumentDate = function () {
      vm.documentDatePicker = {
        startDate: '',
        endDate: '',
      };

      delete vm.filterCriteria.by_date_from;
      delete vm.filterCriteria.by_date_to;

      vm.UtilService.filterResult();
    };

    vm.clearSearch = function () {
      setDefaultFilters();
      vm.fetchResult();
    };

    // private methods
    // -----------------------
    function setConfirmXmls(items) {
      // items.map((item) => {
      items.forEach((item) => {
        item.date = moment(item.date).format(dateDisplay);
        item.provider_name = item.provider.name + ' ' + item.provider.last_name;

        // item.edocs_consecutive = item.edocs_consecutive || '-';
      });
    }

    function validateItemActions(item) {
      item.canDelete = vm.permissions.canDestroy && item.status === 'confirm_later';

      // vm.permissions.canShow && ((item.atv_cr_reception_status === 'fail' || item.atv_cr_reception_status === 'pending'
      // || item.atv_cr_reception_status === 'processing'))

      item.canResend =
        (vm.permissions.canUpdate &&
          vm.atvCrEnabled &&
          item.document_type.numbering_type === 'electronic' &&
          item.atv_status === 'not_sent') ||
        item.atv_status === 'pending' ||
        item.atv_status === 'sent' ||
        item.atv_status === 'received' ||
        item.atv_status === 'processing'; // fail ??

      item.canConvert = vm.permissions.canShow && item.status !== 'confirm_later' && !item.bill;

      // item.canDownload = vm.permissions.canUpdate &&
      // (!vm.atvCrEnabled || (vm.atvCrEnabled && item.document_type.numbering_type === 'electronic' && (item.atv_status === vm.statusAccepted || item.atv_status === vm.statusSent)));

      // item.canNotify   = vm.permissions.canUpdate &&
      // (!vm.atvCrEnabled || (vm.atvCrEnabled && item.document_type.numbering_type === 'electronic' && item.atv_status === vm.statusAccepted));
    }

    function setDefaultFilters() {
      vm.documentDatePicker = {
        startDate: '',
        endDate: '',
      };

      vm.filterCriteria = ConfirmXmlService.getFilterCriteria();

      // vm.filterCriteria.by_status     = 'unpaid';
      // vm.filterCriteria.by_atv_status = vm.atvCrStatuses[0].value;
    }

    function documentDatePicker() {
      let filterByDocumentDate = () => {
        vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
          vm.documentDatePicker.startDate
        );
        vm.filterCriteria.by_date_to = vm.UtilService.startOfDayFormat(
          vm.documentDatePicker.endDate
        );

        vm.UtilService.filterResult();
      };

      vm.documentDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByDocumentDate,
        rangeOptions: config.DOCUMENT_DATE_OPTIONS,
        dateDisplay: dateDisplay,
      });
    }
  }
})();
